import {Component,OnInit} from '@angular/core';
import {  FormBuilder, FormGroup, Validators } from '@angular/forms';
import { STRONG_PASSWORD_PATTERN } from '../../../shared/utils/agency-rbac';

@Component({
  selector: 'app-agency-signup',
  templateUrl: './agency-signup.component.html',
  styleUrl: './agency-signup.component.scss'
})
export class AgencySignupComponent implements OnInit {
  step: number = 1; // init 1
  loading = false;

  /**
   * One-time agency onboarding. Every field has a destination in the database:
   * agency (name, SIRET, raison sociale, siège, optional contact email / phone) and the
   * dirigeant principal (first/last name, login email, phone, civility, function, password).
   */
  agenceInscriptionFormControl: FormGroup = this.fb.group({
    nomAgence: ['', [Validators.required, Validators.maxLength(255)]],
    siret: ['', [Validators.required, Validators.pattern('^[0-9]{14}$')]],
    raisonSociale: [{value:'',disabled: true}, [Validators.required]],
    adresseSiege: [{value:'',disabled: true}, [Validators.required]],
    agencyEmail: ['', [Validators.email, Validators.maxLength(255)]],
    agencyPhone: ['', [Validators.maxLength(32)]],
    dirigeantTitle: [''],
    dirigeantPrenom: ['', [Validators.required, Validators.maxLength(100)]],
    dirigeantNom: ['', [Validators.required, Validators.maxLength(100)]],
    dirigeantFonction: ['', [Validators.maxLength(100)]],
    dirigeantPhone: ['', [Validators.maxLength(32)]],
    email: ['', [Validators.required, Validators.email, Validators.maxLength(50)]],
    password: ['', [Validators.required, Validators.pattern(STRONG_PASSWORD_PATTERN)]],
  });

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
  }

  onSubmit(): any {
    if (this.agenceInscriptionFormControl.valid) {
      console.log(this.agenceInscriptionFormControl.value);
    }
  }

}
